<template>
    <div>
        <slot name="button"></slot>
        <div :class="[down ? 'p-down' : '', right ? 'p-right' : '', `list_pop_up ${dropsize}`]">
            <slot name="dropcontent"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "Dropmenu",
    components: {
    },
    props: {
        showList: {},
        down: Boolean,
        right: Boolean,
        dropsize: {
            type: String,
            default: 'md'
        }
    },
    data: function () {
        return {
            
        };
    },
    methods: {
        toggleDrop(e) {
            if(!this.findParentTag(e.target, this.$el)) {
                this.$el.classList.remove('show')
                this.$emit('closedDropmenu')
            } else if(this.findParentTag(e.target, this.$el.querySelector('.btn'))) {
                this.$el.classList.toggle('show')
            } else {
                this.$el.classList.add('show')
            }
        },
        handleKeyDown(event) {
			if (event.key === 'Escape') {
				document.body.querySelectorAll('.dropmenu-holder').forEach(item => {
                    item.classList.remove('show')
                })
			}
		},
		findParentTag(el, tag) {
			while(el.parentNode) {
				el = el.parentNode;
				if (tag == el) return el;
			}
			return null;
		},
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeyDown);
        document.body.addEventListener('click', this.toggleDrop)
    }
};
</script>

<style lang="css">
.list_pop_up {
    display: none;
    max-height: 200px;
    overflow: auto;
}
.show .list_pop_up {
    display: block;
}
.list_pop_up.lg {
    min-width: 300px;
}
.list_pop_up.xl {
    width: 300px;
    max-height: 400px;
    margin-top: 10px;
}
</style>
